export const FETCH_MOBILE_QUEUE_REQUEST = 'FETCH_MOBILE_QUEUE_REQUEST';
export const FETCH_MOBILE_QUEUE_SUCCESS = 'FETCH_MOBILE_QUEUE_SUCCESS';
export const FETCH_MOBILE_QUEUE_FAILURE = 'FETCH_MOBILE_QUEUE_FAILURE';
